import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';
import {GlobalFunction} from '../core/global_function';


@Injectable()
export class GroupService extends ServiceGlobal {
    group_id: number;
    name: string;
    group_files: string;
    group_students: any;
    activity_id: number;
    activity_no: number;
    tier_of_activity: string = null;
    sub_tier_of_activity: string = null;
    activity_tiers: string;
    class_size: string;
    school_syllabus: boolean;
    time_of_active: string;
    mentors_id: number;
    mentors_name: string;
    document_name: string;
    document_type: string = null;
    school: string = null;
    time_slot: string = null;
    created: any;
    last_post: any;
    mentor_primary: string = null;
    mentor_secondary: string = null;
    mentor_1: string = null;
    mentor_2: string = null;
    mentor_3: string = null;
    mentor_4: string = null;
    createddate: any;
    created_by: any;
    mentor_details: any = [];
    group_supported_label_groups: any = [];
    name_alpha: any = 'name';
    api_find_all: any = 'group_list';
    api_find_one: any = 'groups';
    api_delete: any= 'groups';
    loading: any = false;
    primary_key: any = 'group_id';
    tableName() { return 'group'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "group_id": "Groups ID",
            "mentor_details": "Mentor(s)",
            "group_supported_label_groups": "Applicable Indicators",
            "name":"Group Name",
            "activity_id": "Activity ID",
            "activity_no": "No of Activity",
            "tier_of_activity": "Tier of Activity",
            "sub_tier_of_activity": "Sub-tier of Activity",
            "class_size": "Class Size",
            "school_syllabus": "School Syllabus",
            "time_of_active": "Time of Activity",
            "mentors_id": "Mentor ID",
            "group_mentors": "Mentor(s)",
            "school": "School",
            "created_by": "Created",
            "last_post": "Last post",
            "time_slot": "Timeslot",
            "mentor_primary": "Primary Mentor",
            "mentor_secondary": "Secondary Mentor",
            "document_name": "Document Name",
            "document_type": "Document Type",
            "mentor_1": "Mentor #1",
            "mentor_2": "Mentor #2",
            "mentor_3": "Mentor #3",
            "mentor_4": "Mentor #4",
            "group_files": "",
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "group_id": {
                "type": "int",
                "auto_increment": true,
                "primary_key": true,
                "size": 11
            },
            "name": {
                "type": "string",
                "size": 255,
                "require": {
                    "empty": true,
                },
                'search': {
                    'op'    : 'like',
                    'value' : '%{value}%',
                }
            },
            "class_size": {
                "type": "string",
                "size": 255,
                "require": {
                    "empty": true,
                }
            },
            "school_syllabus": {
                "type": "boolean",
                "require": {
                    "empty": true,
                }
            },
            "time_slot": {
                "type": "string",
                "size": 255,
                "require": {
                    "empty": true,
                }
            },
            "mentor_details": {
                "type": "any"
            },
            "group_supported_label_groups": {
                "type": "any"
            },
            "academic_year": {
                "type": "string",
                "size": 255,
                "require": {
                    "empty": true,
                },
                'search': true,
            },
            "document_name": {
                "type": "string",
                "size": 255,
            },
            "activity_id": {
                "type": "int"
            },
            "activity_tiers": {
                "type": "string"
            },
            "time_of_active": {
                "type": "string"
            },
            "mentors_id": {
                "type": "number"
            },
            "mentors_name": {
                "type": "string"
            },
            "school": {
                "type": "string",
                'search': true
            },
            "created": {
                "type": "date"
            },
            "last_post": {
                "type": "date"
            },
            "mentor_1": {
                "type": "string",
                "size": 255,
                "require": {
                  "empty": true,
                }
            },
            "filter_field": {
              "search": true,
            },
            "school_id": {
              'search': true
            },
            "tier_of_activity": {
                "require": {
                    "empty": true
                }
            }
        });
    }

    async findOneData(id: any, condition: any = {}) {
        // TODO: handle remaining condition parameter (other than $expand which is handled)
        var that = this;
        let resultExpand = {
            'group_mentors/mentor': true,
            'group_files/file': true,
            'group_students/student': true,
            'school': true,
            'group_activity_list/activity_mentor_details': true
        };
        if (condition) {
            const newExpandStr: string = condition.$expand;
            if (newExpandStr) {
                const newExpands = newExpandStr.split(',');
                if (newExpands.length > 0) {
                    for (let newExpand of newExpands) {
                        resultExpand[newExpand] = true;
                    }
                }
            }
        }
        const params = new URLSearchParams({
            $expand: Object.keys(resultExpand).join()
        } as any);
        var rs = await this._db.get(API.API_URL_COMMON + this.api_find_one +'/'+ id + '/details/?' + params.toString());
        for(var k in rs) {
            if(k == 'group_files') {
                var vl = [];
                for(var item_group_file of rs[k]) {
                    Object.assign(item_group_file,item_group_file.file);
                    delete item_group_file.file;
                    vl.push(item_group_file);
                    this.document_type = item_group_file.type;
                    this.document_name = item_group_file.name;
                }
                rs[k] = vl;
            } else if(k == 'group_mentors') {
                for(var i in rs[k]) {
                    this['mentor_' + (parseInt(i) + 1)] = (rs[k][i].mentor && rs[k][i].mentor.username ? rs[k][i].mentor.username : '');
                }
            }
            that[k] = rs[k];
        }
        return rs;
    }

    getAttributesInsert() {
        var rs = {};
        rs['name'] = this.name;
        rs['school'] = this.school;
        rs['tier_of_activity'] = this.tier_of_activity;
        rs['sub_tier_of_activity'] = this.sub_tier_of_activity;
        rs['class_size'] = this.class_size;
        rs['school_syllabus'] = this.school_syllabus;
        rs['time_slot'] = this.time_slot;
        rs['academic_year'] = this.academic_year;
        rs['time_slot'] = this.time_slot;
        rs['group_students'] = this.group_students;
        rs['group_supported_label_groups'] = this.group_supported_label_groups;
        if (!rs['group_supported_label_groups']) {
            rs['group_supported_label_groups'] = [];
        }
        var mentors = [];
        if(this.mentor_1) {mentors.push({"mentor": this.mentor_1, sequence: 1})}
        if(this.mentor_2) {mentors.push({"mentor": this.mentor_2, sequence: 2})}
        if(this.mentor_3) {mentors.push({"mentor": this.mentor_3, sequence: 3})}
        if(this.mentor_4) {mentors.push({"mentor": this.mentor_4, sequence: 4})}
        if(mentors.length) {rs['group_mentors'] = mentors;}
        var group_files = [];
        if(this.group_files && GlobalFunction.is_array(this.group_files)) {
            for(var item of this.group_files) {
                let file: any = {
                    file: item['file_id'],
                    type: this.document_type
                };
                if (this.document_name) {
                    file.name = this.document_name;
                }
                group_files.push(file);
            }
        }
        if(group_files.length) {rs['group_files'] = group_files;}
        return rs;
    }

    getAttributesUpdate() {
        var rs = {};
        rs['group_id'] = this.group_id;
        rs['name'] = this.name;
        rs['school'] = this.school;
        rs['tier_of_activity'] = this.tier_of_activity;
        rs['sub_tier_of_activity'] = this.sub_tier_of_activity;
        rs['class_size'] = this.class_size;
        rs['school_syllabus'] = this.school_syllabus;
        rs['time_slot'] = this.time_slot;
        rs['academic_year'] = this.academic_year;
        rs['time_slot'] = this.time_slot;
        rs['createddate'] = this.createddate;
        rs['created_by'] = this.created_by;
        //rs['group_students'] = this.group_students;
        var mentors = [];

        let existingGroupMentors: any[] = this['group_mentors'] || [];
        for (let mentorIndex = 0; mentorIndex < 4; ++mentorIndex) {
            let mentorId = this['mentor_' + (mentorIndex + 1)];
            if (mentorId) {
                let mentor: any = {
                    mentor: mentorId,
                    group: this.group_id
                };
                if (mentorIndex < existingGroupMentors.length) {
                    let groupMentorId = existingGroupMentors[mentorIndex].group_mentor_id;
                    if (groupMentorId) {
                        mentor.group_mentor_id = groupMentorId;
                    }
                }
                mentors.push(mentor);
            }
        }
        if(mentors.length) {rs['group_mentors'] = mentors;}
        var group_files = [];
        if(this.group_files && GlobalFunction.is_array(this.group_files)) {
            for(var item of this.group_files) {
                var it = {
                    "file": item['file_id'],
                    "type": this.document_type
                };
                if(this.document_name){
                    it['name'] = this.document_name;
                }
                if(item['group_file_id']){
                    it['group_file_id'] = item['group_file_id'];
                }
                if(item['group']){
                    it['group'] = item['group'];
                }
                group_files.push(it);
            }
        }
        if(group_files.length) {rs['group_files'] = group_files;}
        return rs;
    }


    async update() {
        var attributes = this.getAttributesUpdate();
        if (attributes && Object.keys(attributes).length) {
            return this._db.post(API.API_URL_COMMON + this.api_find_one + '/' + this[this.primary_key], attributes).then(res => {
                return Promise.resolve(res);
            });
        } else {
            return Promise.resolve({ code: 200, attributes: this.getAttributes() });
        }
    }

    async insert() {
        let attribute_insert = this.getAttributesInsert();
        if(attribute_insert && Object.keys(attribute_insert).length) {
            return this._db.post(API.API_URL_COMMON + this.api_find_one + '/', attribute_insert).then(rs => {
                return Promise.resolve(rs);
            });
        }
    }

    async getListGroup(id: any, condition: any = {}) {
        let api = API.API_URL_COMMON + this.api_find_one + '/' + id + '/details/?$expand=school';
        return this._db.get(api);
    }

    addStudentToGroup(ids, groupId) {
        if(groupId){
            var link = API.API_URL_COMMON + 'groups/' + groupId + '/add_students';
            return this._db.post(link, ids);
        }
    }

    addStudentToActivityInGroup(ids, activityId) {
      if(activityId){
        var link = API.API_URL_COMMON + 'activities/' + activityId + '/add_students';
        return this._db.post(link, ids);
      }
    }

    async removeStudent(attributes) {
      if (attributes && Object.keys(attributes).length) {
        return this._db.post(API.API_URL_COMMON + this.api_find_one + '/' + this[this.primary_key] + '?$expand=group_students', attributes).then(res => {
          return Promise.resolve(res);
        });
      } else {
        return Promise.resolve({ code: 200, attributes: this.getAttributes() });
      }
    }

    deleteGroupStudent(groupId, studentListHaveRemoved) {
      return this._db.post(API.API_URL_COMMON + 'groups/' + groupId + '/remove_students', studentListHaveRemoved);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/group.service.ts